<template>
    <div>
        <div class="toplogo">
            <div class="logoleft">
                <div>欢迎来到供应链商城</div>
                <div class="himsg" v-if="!isShow">你好，请 &nbsp;<text style="cursor: pointer;" @click="login">登录</text></div>
            </div>
            <div class="right">
                <div v-if="isShow">
                    <img :src="userinfo.headImageUrl" style="width: 50px;height: 50px;">
                </div>
                <div class="menu" @click="goDetail">订单管理</div>
                <div class="menu" @click="goMine">个人中心</div>
                <div class="menu" @click="exitLogin" v-if="isShow">退出登录</div>
            </div>
        </div>
        <div class="top">
            <!-- <div class="topshop">
				<img src="../assets/shop.png" alt="" srcset="">
				<text>店铺名称</text>
				<img src="../assets/change.png" alt="" srcset="">
			</div> -->
            <div class="leftimage">
                <img src="../assets/PClogo.png" alt="" srcset="">
            </div>
            <div class="top-search" @click="chefSearch">
                <div class="sear-left">
                    <img src="../assets/search.png" alt="" srcset="">
                    <text>请输入商品名称或别名</text>
                </div>
                <div class="sear-right">搜索</div>
            </div>
        </div>
        <div class="navlink">
            <div class="nav" v-for="item in navigationList" :key="item.id" :class="current == item.id ? 'select' : ''"
                @click="clickSele(item.id)"> {{ item.name }}
            </div>
        </div>
    </div>
</template>
<script setup>
import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router'
import { getuserinfo } from '../api/index'
const router = useRouter()
const current = ref('0')
const navigationList = ref([])
navigationList.value = [{ id: 0, name: '首页' }, { id: 1, name: '分类' }, { id: 2, name: '快捷下单' }, { id: 3, name: '购物车' }]
onMounted(() => {
    userinfoInit()
})
const path = router.currentRoute.value.path
if (path == '/classification') {
    current.value = 1
} else if (path == '/quickorder') {
    current.value = 2
} else if (path == '/shopCart') {
    current.value = 3
} else if (path == '/' || path == '/home') {
    current.value = 0
}
const login = () => {
    router.push('/login')
}
const isShow = ref(false)
const userinfo = ref('')
const userinfoInit = () => {
    const clientid = ref('')
    clientid.value = localStorage.getItem('clientId')
    isShow.value = true
    if (clientid.value) {
        getuserinfo('').then(res => {
           console.log(res);
        }).catch(err => {
             userinfo.value = err
        })
    } else {
        isShow.value = false
    }

}
const clickSele = (e) => {
    console.log(e);
    current.value = e
    if (e == 0) {
        router.push('/')
    } else if (e == 1) {
        router.push('/classification')
    } else if (e == 2) {
        router.push('/quickorder')
    } else if (e == 3) {
        router.push('/shopCart')
    }
}

const chefSearch=()=> {
    router.push('/search')
}

const goMine = () => {
    console.log(localStorage.setItem('token'));
    
    // router.push('/mine')
}
const goDetail = () => {
    router.push('/ordermanage')

}
const exitLogin = () => {
    localStorage.clear()
    router.push('/login')
}
</script>
<style lang="scss" scoped>
.toplogo {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 30px;
    background-color: #434343;
    color: #fff;

    .logoleft {
        display: flex;
        align-items: center;

        .himsg {
            padding-left: 10px;
        }
    }


    .right {
        font-size: 16px;
        display: flex;
        cursor: pointer;
        align-items: center;
        .menu {
            padding: 0 20px;
        }
    }
}

.top {
    // width: 96%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 200px;

    img {
        width: 20px;
        height: auto;
    }

    .leftimage {
        img {
            width: 320px;
            height: 60px;
        }
    }
}

.topshop {
    display: flex;
    justify-content: center;
    align-items: center;
    // width: 30%;
    padding: 10px 20px;

    text {
        padding: 0 20px;
        color: white;
        font-size: 16px;
        white-space: nowrap;
    }
}

.top-search {
    display: flex;
    justify-content: center;
    padding: 10px 0;
    width: 98%;

    .sear-left {
        width: 60%;
        background-color: #f5f5f5;
        display: flex;
        align-items: center;
        padding: 10px;
        border-radius: 6px;


        text {
            margin-left: 8px;
            color: #787878;
            font-size: 16px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }

    .sear-right {
        color: white;
        background-color: #289d27;
        padding: 10px 28px;
        border-radius: 10px;
        margin-left: 6px;
        font-size: 16px;
        white-space: nowrap;
    }
}

.navlink {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 20px 0;
    color: #32cd32;
    padding: 0 200px;

    // background-color: #32cd32;

    .nav {
        // width: 25%;
        padding: 20px 140px;
        color: #32cd32;
        cursor: pointer;
    }

    & .select {
        background-color: #32cd32;
        color: #fff;
        border-radius: 12px;
    }
}
</style>